import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { extractPlaceholders } from './templateCopy';

/** Kept equal to madkhol-notifier's `BODY_MAX_LENGTH`, sized to fit an FCM message. */
export const BODY_MAX_LENGTH = 1000;
export const TITLE_MAX_LENGTH = 255;

export type CopyFormValues = { titleAr: string; titleEn: string; bodyAr: string; bodyEn: string };

const placeholderHint = (text: string) => {
  const names = extractPlaceholders(text);

  return names.length ? `Placeholders: ${names.map((name) => `{{${name}}}`).join(' ')}` : '';
};

interface TemplateCopyFieldsProps {
  values: CopyFormValues;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  disabled?: boolean;
}

/** The titles and bodies of a template: Arabic on the left, right to left; English on the right. */
export function TemplateCopyFields({ values, onChange, disabled }: TemplateCopyFieldsProps) {
  const textField = (
    field: keyof CopyFormValues,
    label: string,
    options: { dir: 'rtl' | 'ltr'; multiline?: boolean; maxLength: number },
  ) => (
    <TextField
      margin="normal"
      fullWidth
      id={`notification-template-${field}`}
      name={field}
      label={label}
      value={values[field]}
      onChange={onChange}
      multiline={options.multiline}
      minRows={options.multiline ? 4 : undefined}
      required={options.multiline}
      disabled={disabled}
      inputProps={{ dir: options.dir, maxLength: options.maxLength }}
      helperText={
        [placeholderHint(values[field]), options.multiline ? `${values[field].length}/${options.maxLength}` : '']
          .filter(Boolean)
          .join(' · ') || (options.multiline ? '' : 'Leave empty to show مدخول / Madkhol')
      }
    />
  );

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={6}>
        {textField('titleAr', 'Title (Arabic)', { dir: 'rtl', maxLength: TITLE_MAX_LENGTH })}
        {textField('bodyAr', 'Body (Arabic)', { dir: 'rtl', multiline: true, maxLength: BODY_MAX_LENGTH })}
      </Grid>
      <Grid item xs={12} md={6}>
        {textField('titleEn', 'Title (English)', { dir: 'ltr', maxLength: TITLE_MAX_LENGTH })}
        {textField('bodyEn', 'Body (English)', { dir: 'ltr', multiline: true, maxLength: BODY_MAX_LENGTH })}
      </Grid>
    </Grid>
  );
}
